import React from "react";
import {observer} from "mobx-react";
import {IFormField} from "../../../../../models/forms/form-field.interface";
import {
    IPsoFamilyAgreementViewModel,
    SpecificDegreeOfKinshipTypeEnum
} from "../../../../../services/booking/models/pso/agreements/families/pso-family-agreement.view-model.interface";
import {ReadonlyCheckboxComponent} from "../../../../../basic-components/checkbox/readonly-checkbox.component";
import styled from "styled-components";
import {
    IPsoFamilySpecificDegreeTypeViewModel
} from "../../../../../services/booking/models/pso/agreements/families/options/pso-family-specific-degree-type.view-model.interface";
import {FullGridLineBox} from "../../common/boxes/pso-agreement.boxes";


const OptionsContainerBox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    gap: ${props => props.theme.spacing.flexGap24};
`

const SpecificDegreeOptionComponent: React.FC<{option: IPsoFamilySpecificDegreeTypeViewModel, field: IFormField<SpecificDegreeOfKinshipTypeEnum>}> = observer((props) => {
    const isChecked = props.field.value === props.option.value;
    const onClick = () => {
        if(isChecked) {
            props.field.setValue(null);
        } else {
            props.field.setValue(props.option.value);
        }
    }

    return (
        <ReadonlyCheckboxComponent checked={isChecked} onClick={onClick} label={props.option.name} labelPlacement={'end'}/>
    )
})

export const SpecificDegreeOfKinshipTypeFieldEditorComponent: React.FC<{familyAgreement: IPsoFamilyAgreementViewModel}> = observer((props) => {

    if(props.familyAgreement.fields.specificDegreeOfKinshipType.isHidden) {
        return null;
    }

    return (

        <FullGridLineBox>
            <OptionsContainerBox>
                {props.familyAgreement.specificDegreeOfKinshipOptions.map(option => <SpecificDegreeOptionComponent
                    key={option.value} option={option}
                    field={props.familyAgreement.fields.specificDegreeOfKinshipType}/>)}
            </OptionsContainerBox>
        </FullGridLineBox>


    )
})